(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-countdown')) {
    class PfCountdown extends HTMLElement {
      connectedCallback() {
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      target() {
        const now = new Date();
        if (this.dataset.mode === 'date' && this.dataset.end) {
          const end = new Date(this.dataset.end.replace(' ', 'T'));
          if (!isNaN(end)) return end;
        }
        // Daily mode: count down to the next local midnight
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        return midnight;
      }

      tick() {
        const diff = Math.max(0, this.target() - new Date());
        const total = Math.floor(diff / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        this.hours.textContent = pad(Math.floor(total / 3600));
        this.minutes.textContent = pad(Math.floor((total % 3600) / 60));
        this.seconds.textContent = pad(total % 60);
      }
    }
    customElements.define('pf-countdown', PfCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-cart-drawer"]) return;
  try {
    
  if (!customElements.get('pf-cart-drawer')) {
    class PfCartDrawer extends HTMLElement {
      connectedCallback() {
        window.pfCartDrawer = this;
        this.panel = this.querySelector('.pf-cart__panel');

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-close]')) return this.close();
          const qtyButton = event.target.closest('[data-qty]');
          if (qtyButton) {
            const item = qtyButton.closest('[data-key]');
            this.change(item.dataset.key, Number(qtyButton.dataset.qty), item);
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });

        // Open the drawer from the header cart icon instead of going to the cart page
        document.addEventListener('click', (event) => {
          const link = event.target.closest(`a[href="${this.dataset.cartUrl}"]`);
          if (!link || this.contains(link) || document.querySelector('main[data-template="cart"]')) return;
          if (!link.closest('header, #header-group')) return;
          event.preventDefault();
          this.open();
        });
      }

      open() {
        this.lastFocus = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.classList.add('pf-cart-open');
        requestAnimationFrame(() => this.panel.focus());
      }

      close() {
        this.classList.remove('is-open');
        document.documentElement.classList.remove('pf-cart-open');
        this.lastFocus?.focus?.();
      }

      async add(formData) {
        formData.append('sections', this.dataset.section);
        formData.append('sections_url', window.location.pathname);
        const response = await fetch(`${this.dataset.addUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const data = await response.json();
        if (!response.ok) throw new Error(this.dataset.error);
        this.render(data.sections?.[this.dataset.section]);
        this.open();
      }

      async change(key, quantity, item) {
        item?.classList.add('is-loading');
        try {
          const response = await fetch(`${this.dataset.changeUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity: Math.max(0, quantity),
              sections: [this.dataset.section],
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(this.dataset.error);
          this.render(data.sections?.[this.dataset.section]);
        } catch (error) {
          item?.classList.remove('is-loading');
          this.showError(error.message);
        }
      }

      async refresh() {
        const response = await fetch(`${window.location.pathname}?sections=${this.dataset.section}`);
        const data = await response.json();
        this.render(data[this.dataset.section]);
      }

      render(html) {
        if (!html) return this.refresh();
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-content]');
        const current = this.querySelector('[data-content]');
        if (!next || !current) return;
        current.replaceWith(next);
        this.updateBubble(Number(next.dataset.count || 0));
      }

      showError(message) {
        const el = this.querySelector('[data-error-message]');
        if (!el) return;
        el.textContent = message || this.dataset.error;
        el.hidden = false;
      }

      updateBubble(count) {
        document.querySelectorAll('cart-icon').forEach((icon) => {
          const bubble = icon.querySelector('[ref="cartBubble"]');
          const number = icon.querySelector('[ref="cartBubbleCount"]');
          icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
          bubble?.classList.toggle('visually-hidden', count === 0);
          number?.classList.toggle('hidden', count === 0);
          if (number) number.textContent = count < 100 ? String(count) : '';
        });
      }
    }
    customElements.define('pf-cart-drawer', PfCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-gallery')) {
    class PfGallery extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-thumb]');
          if (!thumb) return;
          const index = thumb.dataset.thumb;
          this.querySelectorAll('[data-slide]').forEach((el) => el.classList.toggle('is-active', el.dataset.slide === index));
          this.querySelectorAll('[data-thumb]').forEach((el) => el.classList.toggle('is-active', el === thumb));
          const strip = thumb.parentElement;
          const offset = thumb.getBoundingClientRect().left - strip.getBoundingClientRect().left;
          strip.scrollTo({ left: strip.scrollLeft + offset - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
        });
      }
    }
    customElements.define('pf-gallery', PfGallery);
  }

  if (!customElements.get('pf-bundles')) {
    class PfBundles extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.pf-product__submit');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.addEventListener('change', (event) => {
          if (event.target.type !== 'radio') return;
          const selectedTier = event.target.closest('.pf-tier');
          this.querySelectorAll('.pf-tier').forEach((tier) => {
            tier.classList.toggle('is-selected', tier === selectedTier);
          });
          const quantity = this.querySelector('[data-quantity]');
          if (quantity) quantity.value = event.target.value;

          const total = this.querySelector('[data-button-total]');
          if (total && event.target.dataset.total) total.textContent = event.target.dataset.total;

          this.replay(selectedTier, 'is-popping');
          this.replay(this.button, 'is-bumping');
        });

        // Add to cart without leaving the page when the cart drawer is available
        this.addEventListener('submit', async (event) => {
          const drawer = window.pfCartDrawer;
          if (!drawer) return;
          event.preventDefault();
          const button = this.button;
          button?.classList.add('is-loading');
          button?.setAttribute('aria-busy', 'true');
          button?.setAttribute('disabled', '');
          try {
            await drawer.add(new FormData(event.target));
            this.celebrate();
          } catch (error) {
            drawer.open();
            drawer.showError(error.message);
          } finally {
            button?.classList.remove('is-loading');
            button?.removeAttribute('aria-busy');
            button?.removeAttribute('disabled');
          }
        });
      }

      // Restart a CSS animation class even if it is already applied
      replay(element, className) {
        if (!element || this.reduceMotion) return;
        element.classList.remove(className);
        void element.offsetWidth;
        element.classList.add(className);
        element.addEventListener('animationend', () => element.classList.remove(className), { once: true });
      }

      celebrate() {
        const button = this.button;
        if (!button) return;
        button.classList.add('is-added');
        clearTimeout(this.addedTimer);
        this.addedTimer = setTimeout(() => button.classList.remove('is-added'), 1800);

        document.querySelectorAll('cart-icon').forEach((icon) => this.replay(icon, 'pf-cart-bounce'));
        if (this.reduceMotion) return;

        const paw = button.querySelector('.pf-product__submit-added .pf-icon');
        if (!paw) return;
        for (let i = 0; i < 6; i++) {
          const print = paw.cloneNode(true);
          print.classList.add('pf-paw-burst');
          const angle = (-150 + i * 24) * (Math.PI / 180);
          const distance = 46 + Math.random() * 22;
          print.style.setProperty('--pf-x', `${Math.cos(angle) * distance}px`);
          print.style.setProperty('--pf-y', `${Math.sin(angle) * distance}px`);
          print.style.setProperty('--pf-r', `${Math.round(Math.random() * 60 - 30)}deg`);
          print.style.animationDelay = `${i * 40}ms`;
          button.appendChild(print);
          print.addEventListener('animationend', () => print.remove(), { once: true });
        }
      }
    }
    customElements.define('pf-bundles', PfBundles);
  }

  if (!customElements.get('pf-sticky-bar')) {
    class PfStickyBar extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        this.querySelector('[data-scroll]')?.addEventListener('click', () => {
          this.target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        if (!this.target || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', passed);
        });
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
    customElements.define('pf-sticky-bar', PfStickyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-carousel')) {
    class PfCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.update();
      }

      step() {
        const card = this.track.firstElementChild;
        if (!card) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      go(direction) {
        this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('pf-carousel', PfCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-count-up')) {
    class PfCountUp extends HTMLElement {
      connectedCallback() {
        this.numbers = [...this.querySelectorAll('[data-count]')];
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

        this.numbers.forEach((el) => (el.textContent = '0'));
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.animate();
          },
          { threshold: 0.3 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      animate() {
        const duration = 1600;
        const start = performance.now();
        const frame = (now) => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.numbers.forEach((el) => {
            el.textContent = Math.round(Number(el.dataset.count) * eased);
          });
          if (progress < 1) requestAnimationFrame(frame);
        };
        requestAnimationFrame(frame);
      }
    }
    customElements.define('pf-count-up', PfCountUp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-video-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.pf-video [data-play]');
    if (!button) return;
    const video = button.closest('.pf-video').querySelector('video');
    if (!video) return;
    if (video.paused) {
      document.querySelectorAll('.pf-video video').forEach((other) => other !== video && other.pause());
      video.muted = true;
      video.play();
      button.classList.add('is-playing');
    } else {
      video.pause();
      button.classList.remove('is-playing');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
